import {
    normalizeShareOrigin,
    resolveConfiguredShareOrigin as resolveShareOrigin,
} from "./shareRouteOrigin";

export const BANDS_ROUTE_PREFIX = "/bands";
export const BAND_HANDLE_ROUTE_PREFIX = `${BANDS_ROUTE_PREFIX}/@`;
export const DEFAULT_BAND_SHARE_ORIGIN = "https://muzone.co";
export const MAX_BAND_HANDLE_LENGTH = 96;
export const BAND_HANDLE_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const normalizeBandRouteHandle = (value) => {
    if (typeof value !== "string") {
        return null;
    }
    return value.length <= MAX_BAND_HANDLE_LENGTH && BAND_HANDLE_PATTERN.test(value) ? value : null;
};

export const buildBandHandlePath = (handle) => {
    const normalizedHandle = normalizeBandRouteHandle(handle);
    return normalizedHandle ? `${BAND_HANDLE_ROUTE_PREFIX}${encodeURIComponent(normalizedHandle)}` : null;
};

export const buildBandsPath = () => BANDS_ROUTE_PREFIX;

export const buildBandPath = (band) => {
    return buildBandHandlePath(band?.handle) || buildBandHandlePath(band?.publicHandle);
};

const trimTrailingSlash = (pathname) => (
    typeof pathname === "string"
        ? (pathname.replace(/\/+$/, "") || "/")
        : ""
);

export const isBandsRoutePath = (pathname) => {
    const normalizedPathname = trimTrailingSlash(pathname);
    return normalizedPathname === BANDS_ROUTE_PREFIX
        || normalizedPathname.startsWith(`${BANDS_ROUTE_PREFIX}/`);
};

export const getBandRouteLocator = (pathname) => {
    const normalizedPathname = trimTrailingSlash(pathname);
    if (normalizedPathname === BANDS_ROUTE_PREFIX) {
        return null;
    }
    if (!normalizedPathname.startsWith(`${BANDS_ROUTE_PREFIX}/`)) {
        return null;
    }
    const withoutPrefix = normalizedPathname.slice(BANDS_ROUTE_PREFIX.length + 1);
    const segments = withoutPrefix.split("/").filter(Boolean);
    if (segments.length < 1 || segments.length > 2) {
        return null;
    }
    if (segments[0].startsWith("@")) {
        if (segments.length !== 1) {
            return null;
        }
        const rawHandle = segments[0].slice(1);
        let handle = null;
        try {
            handle = normalizeBandRouteHandle(decodeURIComponent(rawHandle));
        } catch (_) {
            handle = null;
        }
        return handle
            ? {
                type: "handle",
                value: handle,
                slug: rawHandle,
            }
            : null;
    }
    return null;
};

const resolveConfiguredShareOrigin = () => {
    return resolveShareOrigin(
        process.env.REACT_APP_BAND_SHARE_BASE_URL,
        DEFAULT_BAND_SHARE_ORIGIN,
    );
};

export const buildBandShareUrl = (band, origin = resolveConfiguredShareOrigin()) => {
    const bandPath = buildBandPath(band);
    const normalizedOrigin = normalizeShareOrigin(origin);
    if (!bandPath || !normalizedOrigin) {
        return null;
    }

    return new URL(bandPath, normalizedOrigin).toString();
};
